(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kd-insulation-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("kd-insulation-guide")) {
    customElements.define(
      "kd-insulation-guide",
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener("click", (event) => {
            const trigger = event.target.closest("[data-kd-thermal-target]");

            if (!trigger) return;

            const thermalInput = document.getElementById(trigger.dataset.kdThermalTarget);

            if (!thermalInput || thermalInput.disabled) return;

            thermalInput.click();
            thermalInput.focus();
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
